import { SHOW_LOG } from "Utils/constants";
import { http } from "Utils/http";
import { store } from 'Store';
import { PATHS } from "./PagePaths";
import { httpDownload } from "./httpDownload";
import { matchPath } from 'react-router-dom';

export const isLoggedIn = () => {
    if (store.getState().loginInfo?.token) {
        return true;
    }
    else {
        return false;
    }
}

export const slugify = (title) => {
    return title
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .replace(/ /g, '-')
        .toLowerCase();
}

export function getOrdinalSuffix (day) {
    if (day > 3 && day < 21)
        return day + 'th';
    switch (day % 10) {
        case 1:
            return (day + 'st');
        case 2:
            return (day + 'nd');
        case 3:
            return (day + 'rd');
        default:
            return (day + 'th');
    }
}

export const getDocumentDownloadCall = async (groupId) => {

    //console.log(groupId);
    var url = '/api/dlms/downloadDocument';
    const loginState = store.getState().loginInfo;
    //console.log(loginState);
    return httpDownload.post(url, { "groupId": groupId }, {
        responseType: 'blob',
        headers: {
            "Authorization": "Bearer " + loginState.token
            //"Referrer-Policy": "strict-origin-when-cross-origin"
        },
        onDownloadProgress: (progressEvent) => {
            //console.log(progressEvent);
        }
    });
}

export const handleFileDownload = async (groupId, onError, onDownloadComplete) => {
    if (groupId != null && groupId != "") {
        return getDocumentDownloadCall(groupId).then((res) => {
            //console.log(res);
            //console.log(res.headers);
            //console.log(res.headers['content-disposition']);
            // get filename from the res content-disposition
            const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');

            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  

            //return d;
        }).catch((error) => {
            if (onError != null) {
                onError(error);
            }
            //console.log("Error caught while loading data: " + error);


        }).finally(() => {
            if (onDownloadComplete != null) {
                onDownloadComplete();
            }
            //console.log("Download Done");

        });
    }
}

export const formatDocDate = (value) => {
    const specificDate = new Date(value);
    // Long date with full weekday (e.g., Wednesday, October 29, 2025)
    const longDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }).format(specificDate);

    var split = longDate.split(" ");
    split[1] = getOrdinalSuffix(specificDate.getDate()) + ",";
    var date = split[0] + " " + split[1] + " " + split[2];
    return date;
}

export const getDocInfo = async (groupId, setFunc) => {
    if (groupId != null && groupId != "") {
        getDocumentInfo(groupId).then((res) => {
            //console.log(res);
            var d = res.data;
            setFunc(d);

            return d;
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);


        });
    }
}

export const getFileDownloadUrl = async (groupId, fileName) => {
    return getDocumentDownloadCall(groupId).then((res) => {
        if (res) {
            //console.log(res);
            //console.log(res.headers);
            //console.log(res.headers['content-disposition']);
            // get filename from the res content-disposition
            //console.log(res.headers["content-disposition"]?.split('filename='));
            //const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            const filename = res.headers["content-disposition"]?.split('filename=')[1];
            //console.log(filename);
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            a.text = res.headers["content-disposition"]?.split('filename=')[1];
            a.download = res.headers["content-disposition"]?.split('filename=')[1];

            //document.body.appendChild(a); // append the element to the dom
            return {
                href: url,
                filename: filename,
            };
        }
        else {
            return null;
        }
    });


}


export const getVarValue = function (value, params) {
    if (typeof value === 'function') {
        return value(params);
    }
    else {
        return value;
    }
};

export const isPublicPage = (location) => {
    var pathname = location.pathname;
    if (pathname != null && (pathname.includes("publicpages") || pathname.match(PATHS.public.Search + "/.*"))) {
        //console.log("isPublic - publicpages", pathname);
        return true;
    } else {
        var isTrue = true;
        /**TODO"! 01/21/2026: to clean below comment once tested */
        // var isTrue = false;
        // Object.keys(PATHS.public).some(key => {
        //     ////console.log("isPublic - key - " + key);
        //     ////console.log("isPublic - value - " + PATHS.public[key]);
        //     ////console.log("isPublic - pathname - " + pathname)
        //     ////console.log(`Pathname: ${pathname}, Value: ${PATHS.public[key]}`);
        //     if (PATHS.public[key].trim() == pathname) {
        //         ////console.log(pathname);
        //         ////console.log(PATHS.public[key]);
        //         isTrue = true;
        //         return true;
        //     }
        // });
        // return isTrue;
        Object.keys(PATHS.private).some(key => {
            //console.log("isPrivate - key - ", key);
            //private path which contains the place holder variable
            if (PATHS.private[key].trim().includes(":oT")) {
                let privatePath = PATHS.private[key].trim();
                //PSO
                if (privatePath.replace(":oT", "PSO") == pathname) {
                    isTrue = false;
                }
                //Admin
                if (privatePath.replace(":oT", "Admin") == pathname) {
                    isTrue = false;
                }
                //Vendor
                if (privatePath.replace(":oT", "Vendor") == pathname) {
                    isTrue = false;
                }
            }

            if (PATHS.private[key].trim() == pathname) {
                isTrue = false;
            }
        });
        return isTrue;
    }
}

export const getPublicPageNameFromPath = (pathname) => {
    //console.log(pathname);

    for (const key in PATHS.public) {

        const match = matchPath(PATHS.public[key].trim(), pathname);

        if (PATHS.public[key].trim() == (pathname)) {//(match!=null ? match.pattern.path : pathname)) {
            return key;
        }
    };

}

export const getPageMatches = (pathname) => {


    for (const key in PATHS.public) {

        const match = matchPath(PATHS.public[key].trim(), pathname);

        if (match) {
            // console.log('It matches!');
            // console.log(match.params); // Output: { category: 'tech', slug: 'react-router-tips' }
            return match;
        } else {
            //console.log('No match found.');
        }

    };

}

export const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) {
        newWindow.opener = null
    }
}

export const openInNewTabWithState = (url, state) => {
    localStorage.setItem("newTabState", state);
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) {
        newWindow.opener = null
    }
}

export const getRandomInt = (min, max) => {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
}

export const print = (string) => {
    if (SHOW_LOG == true) {
        //console.log(string);
    }
}

export const isInObject = (name, object) => {
    if (object != null) {
        if (name in object) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

export const trimNumber = (value, maxLength, maxValue, minValue) => {
    ////console.log(value);
    ////console.log(maxLength);
    ////console.log(maxValue);
    ////console.log(minValue);
    if (minValue != null) {
        if (value < minValue) {
            return "";//"Number(minValue)";
        }
    }
    if (maxValue != null && (maxValue) > 0 && value != null && value != "") {
        if (value > maxValue) {
            var s = value.toString();

            if (maxLength != null && Number(maxLength) > 0) {
                var sub = s.substr(0, Number(maxLength));
                return Number(sub);
            }
            else {
                return Number(maxValue);
            }
        }
    }
    ////console.log(value);
    return value;
}

export const trimString = (value, maxLength) => {
    ////console.log(value);
    ////console.log(maxLength);
    if (maxLength != null && Number(maxLength) > 0 && value != null) {
        var l = value.length;
        ////console.log(l);
        if (l > maxLength) {
            //var s = value.toString();
            var sub = value.substr(0, maxLength);
            return sub;
        }
    }
    return value;
}

//Ensures that year field is only 4 numbers
//Should be used for onChange event on date input
export const applyDateSelectorFormat = (val) => {
    //console.log(val);

    if (val != null) {
        var split = val.split("-");
        if (split[0].length > 4) {
            return (val.substring(val.length - 7, val.length)).padStart(10, "0");
        }
        else {
            return val;
        }
    }
    else {
        return '';
    }
}

//Formats a Date using local (not UTC) parts, matching native <input type="date"> value format
const toDateInputValue = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

//Today's date as a yyyy-mm-dd string, using the user's system clock
export const getTodayDateInputValue = () => {
    return toDateInputValue(new Date());
}

//Quick range: previous calendar month
export const getLastMonthRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 0);
    return { start: toDateInputValue(start), end: toDateInputValue(end) };
}

//Quick range: previous calendar quarter (Jan-Mar/Apr-Jun/Jul-Sep/Oct-Dec)
export const getLastQuarterRange = () => {
    const now = new Date();
    const currentQuarterStartMonth = Math.floor(now.getMonth() / 3) * 3;
    const lastQuarterStartMonth = currentQuarterStartMonth - 3;
    const start = new Date(now.getFullYear(), lastQuarterStartMonth, 1);
    const end = new Date(now.getFullYear(), lastQuarterStartMonth + 3, 0);
    return { start: toDateInputValue(start), end: toDateInputValue(end) };
}

//Quick range: calendar year to date
export const getYearToDateRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    return { start: toDateInputValue(start), end: toDateInputValue(now) };
}

//Returns true if date input is empty
//Example: onKeyUp={isDateEmpty}
export const isDateEmpty = (e) => {
    var val = e.target.value;
    if (e.target.validity.valid == true) {
        if (val != null && val.length > 0) {
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
}

export const formatDate = (time) => {
    if (time == null) {
        return null;
    }
    else {
        let date = new Date(time);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let min = date.getMinutes();
        return (
            <div>
                {month < 10 ? "0" + month : month}/
                {day < 10 ? "0" + day : day}/
                {year + " "}
                {hour < 10 ? "0" + hour : hour}:
                {min < 10 ? "0" + min : min}
            </div>
        )
    }

}

function getPrefixData (list, emptyDisplayValue) {
    var selectPrefixData = [];

    selectPrefixData.push({
        index: null,
        value: -1,
        title: null,
        displayValue: emptyDisplayValue ? "" : "Select Prefix",
        isSelected: true
    });

    for (var i = 0; i < list.length; i++) {
        var x = list[i];
        selectPrefixData.push({
            index: i,
            value: x.prefix,
            title: "Select prefix " + x.prefix,
            displayValue: x.prefix,
            isSelected: false
        });
    }

    return selectPrefixData;
}

function getSuffixData (list, emptyDisplayValue) {
    var selectSuffixData = [];

    selectSuffixData.push({
        index: null,
        value: -1,
        title: null,
        displayValue: emptyDisplayValue ? "" : "Select Suffix",
        isSelected: true
    });

    for (var i = 0; i < list.length; i++) {
        var x = list[i];
        selectSuffixData.push({
            index: i,
            value: x.suffix,
            title: "Select suffix " + x.suffix,
            displayValue: x.suffix,
            isSelected: false
        });
    }

    return selectSuffixData;
}


function getStateData (list, emptyDisplayValue) {
    var selectStateData = [];

    selectStateData.push({
        index: -1,
        value: null,
        title: null,
        displayValue: emptyDisplayValue ? "" : "Select State",
        isSelected: true
    });

    for (var i = 0; i < list.length; i++) {
        var x = list[i];
        selectStateData.push({
            index: i,
            value: x.regionId,
            title: null,
            displayValue: x.name,
            isSelected: false
        });
    }

    return selectStateData;
}

export const getPrefixAndSuffixList = (errorHandle, emptyDisplayValue) => {
    //console.log("getPrefixAndSuffixList");
    var url = '/api/manage/info/prefixAndSuffixList';

    const loginState = store.getState().loginInfo;

    const res = http.post(url, null, {
        headers: {
            "Authorization": "Bearer " + loginState.token
        }
    }).then((response) => {
        if (response.data != null) {
            //console.log(response.data);

            var prefixList = response.data.prefixList;
            var suffixList = response.data.suffixList;
            var prefixSelectData = getPrefixData(prefixList, emptyDisplayValue);
            var suffixSelectData = getSuffixData(suffixList, emptyDisplayValue);

            return {
                prefixData: prefixSelectData,
                suffixData: suffixSelectData
            };
        }
        else {
            errorHandle();
            //dispatch(setStatus(STATUSES.ERROR));
            //dispatch(setPopup({visible: true, title: ERROR_MESSAGES.DATA_ERROR.title, msg: ERROR_MESSAGES.DATA_ERROR.message, showContactHelp: true }));
        }
    }).catch(function (error) {
        //console.log(error);
        errorHandle(error);
    });
    //console.log(res);
    return res;
}


export const getRegionList = async (errorHandle, emptyDisplayValue) => {
    //console.log("getRegionList");
    var url = '/api/manage/info/regionList';
    const loginState = store.getState().loginInfo;
    const res = http.post(url, null, {
        headers: {
            "Authorization": "Bearer " + loginState.token
        }
    }).then((response) => {
        if (response.data != null) {
            //console.log(response.data);

            var stateList = response.data.demographics;
            var stateSelectData = getStateData(stateList, emptyDisplayValue);

            return {
                stateData: stateSelectData,
            };
        }
        else {
            errorHandle();
            //dispatch(setStatus(STATUSES.ERROR));
            //dispatch(setPopup({visible: true, title: ERROR_MESSAGES.DATA_ERROR.title, msg: ERROR_MESSAGES.DATA_ERROR.message, showContactHelp: true }));
        }
    }).catch(function (error) {
        //console.log(error);
        errorHandle(error);
        /*setGlobalErrorStatus({
            dispatch: useDispatch(),
            popupData: {
                visible: true, 
                title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                showContactHelp: true 
            },
            redirect: {
                redirect: false, 
                redirectFirst: false,
                path: "", 
                data: {}
            }
        });*/

    });
    //console.log(res);
    return res;
}


function getLoggedInUserData (data) {
    //var selectStateData = [];



    return data;
}

export const getLoggedInUserInfo = async (errorHandle) => {
    //console.log("getLoggedInUserInfo");
    var url = '/api/manage/getMyaccount';
    const loginState = store.getState().loginInfo;
    const res = http.post(url, null, {
        headers: {
            "Authorization": "Bearer " + loginState.token
        }
    }).then((response) => {
        if (response.data != null) {
            //console.log(response.data);
            var userInfo = response.data.userInfo;
            var userInfoData = getLoggedInUserData(userInfo);

            return {
                userInfo: userInfoData,
            };
        }
        else {
            errorHandle();

        }
    }).catch(function (error) {
        //console.log(error);
        errorHandle(error);


    });
    //console.log(res);
    return res;
}

function getOrganizationListData (data) {
    //var selectStateData = [];



    return data;
}

export const getOrganizationList = async (errorHandle) => {
    //console.log("getOrganizationListInfo");
    var url = '/api/org/getorganizations';
    const loginState = store.getState().loginInfo;
    const res = http.post(url, null, {
        headers: {
            "Authorization": "Bearer " + loginState.token
        }
    }).then((response) => {
        if (response.data != null) {
            //console.log(response.data);
            //var userInfo = response.data.userInfo;
            var orgListData = getOrganizationListData(response.data);

            return {
                orgList: orgListData,
            };
        }
        else {
            errorHandle();

        }
    }).catch(function (error) {
        //console.log(error);
        errorHandle(error);


    });
    //console.log(res);
    return res;
}


function getDocumentInfoData (data) {
    //var selectStateData = [];



    return data;
}

export const getDocumentInfo = async (groupId, errorHandle) => {
    //console.log("getDocumentInfo");
    const loginState = store.getState().loginInfo;
    var url = '/api/dlms/documentInfo';
    //var values = {
    //    firstname : getFieldValue(userFirstName,null),
    //}
    //const loginState = store.getState().loginInfo;
    var values = {
        groupId: groupId
    };
    const res = http.post(url, { "groupId": groupId }, {
        headers: {
            "Authorization": "Bearer " + loginState.token
        }
    }).then((response) => {
        return response;
        /*if(response.data!=null){
            //console.log(response.data);
            //var userInfo = response.data.userInfo;
            var docInfoData = getDocumentInfoData(response.data);
           
            return {
                docInfo: docInfoData,
            };
        }
        else{
            
            
        }*/
    }).catch(function (error) {
        //console.log(error);
        //errorHandle(error);


    });
    //console.log(res);
    return res;
}


export const getDocumentPublicInfo = async (groupId, errorHandle) => {
    //console.log("getDocumentPublicInfo");
    var url = '/api/dlms/documentInfo';

    return http.post(url, { "groupId": groupId }, {
        headers: {

        }
    })
}

// mask the email: Ex. c***@gmail.com
export const maskEMail = (email) => {

    if (email.includes('@')) {
        // split into user name and domain
        const [username, domain] = email.split('@');
        const maskedEmail = email.charAt(0) + "***@" + domain;

        return maskedEmail;
    }

    return email;
} 